import * as React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import Paper from "@mui/material/Paper";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import {
  getFileNameFromAssetUrl,
  formatFileSize,
} from "../../../helpers/utils";
import assetsService from "../../../service/assets.service";
import { CircularProgress } from "@mui/material";

export const AddFileBox = styled(Box)(({ theme }) => {
  const isDark = theme.palette.mode === "dark";
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: isDark ? "#152033" : "#eee",
    border: `dashed 2px ${isDark ? "#2c3a55" : "#bbb"}`,
    borderRadius: "5px",
    height: "50px",
    cursor: "pointer",
    color: theme.palette.text.primary,
    "&:hover": {
      background: isDark ? "#1e293b" : "#ddd",
    },
  };
});

export default function AttachedFileItem({
  url,
  onRemove,
  mb,
  mr,
  inline,
  bottomPart,
}: {
  url: string;
  onRemove?: () => void;
  mb?: number;
  mr?: number;
  inline?: boolean;
  bottomPart?: React.ReactNode;
}) {
  const [downloadingFile, setDownloadingFile] = React.useState(false);
  const downloadFile = async () => {
    if (downloadingFile) return;
    setDownloadingFile(true);
    await assetsService.downloadFile({ fileName: url });
    setDownloadingFile(false);
  };
  const fileName = getFileNameFromAssetUrl(url);
  return (
    <Box
      component="span"
      sx={{ display: inline ? "inline-block" : "block", width: "100%" }}
    >
      <Paper
        sx={{
          pt: "4px",
          display: inline ? "inline-flex" : "flex",
          alignItems: "center",
          flex: 1,
          pl: "8px",
          pr: 2,
          border: "solid 1px",
          borderColor: (theme) =>
            theme.palette.mode === "dark" ? "#2c3a55" : "#eee",
          mb: mb ? `${mb}px` : undefined,
          mr: mr ? `${mr}px` : undefined,
          minHeight: "33px",
        }}
      >
        <Box mr={1}>
          {downloadingFile ? (
            <CircularProgress size={16} />
          ) : (
            <FilePresentIcon sx={{ fontSize: "25px", opacity: "0.6" }} />
          )}
        </Box>
        <Box
          sx={{
            flex: 1,
            mb: "5px",
            wordWrap: "break-word",
            overflow: "hidden",
          }}
        >
          <Tooltip title={fileName} arrow>
            <Box
              sx={{
                cursor: "pointer",
                "&:hover": {
                  color: "primary.main",
                  textDecoration: "underline",
                },
              }}
              className="ellipsis-line-1"
              onClick={() => downloadFile()}
            >
              {getFileNameFromAssetUrl(url)}
            </Box>
          </Tooltip>
          {bottomPart}
        </Box>
        {onRemove ? (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton onClick={() => onRemove()}>
              <CloseIcon />
            </IconButton>
          </Box>
        ) : null}
      </Paper>
    </Box>
  );
}
